import React, { useState, useEffect } from 'react';
import { Table, Thead, Tbody, Tr, Th, Td } from 'react-super-responsive-table';
//import { API } from 'aws-amplify';
import '../components/estilos.css';
import {
    createUbicacion as createUbicacionMutation, updateUbicacion as updateUbicacionMutation,
    createLocacion, updateLocacion, updateRecibaSeriales,
    createRecibaSerialesMP,
    updateRecibaSerialesMP,
    deleteRecibaSerialesMP,
    createCambios
} from '../graphql/mutations';
import Moment from 'moment';
import { GetPProduccion, GetPlaneacion, GetUbicacion, GetLocaciones, GetRecibaSeriales, GetRecibaID, GetRecibaSerialesID, GetLocacionesID, GetRecibaSerialesIDMP, GetRecibaSerialesMP } from '../components/queries/Queries'
import { decodificarTextoJSON, ObtenerUbicaciones } from '../components/queries/DCUbicaciones';
import { regresarAPlanta } from '../components/queries/Mutations';
import { generateClient } from "aws-amplify/api";

const API = generateClient();
const initialFormState = {
    id: "", RecibaSerialesID: "", lote: "", serial: "", ubicacion: "", locacion: "", espacioOcupado: 0, comentarios: "", activo: true, orden: 0,
    fechaIngreso: "", horaIngreso: "00:00", fechaSalida: "", horaSalida: "00:00", Reg_Ins_Usuario: "", Reg_Mod_Usuario: ""
}

const initialfFormState = { formType: 'Ubicación' }
export default function useUbicacion() {
    //Declaración de variables    
    const [reciba, setReciba] = useState([]);
    //const [cReciba, setCReciba] = useState([]);
    const [recibaSinFiltro, setRecibaSinFiltro] = useState([]);
    const [locaciones, setLocaciones] = useState([]);
    const [pProduccion, setPProduccion] = useState([]);
    const [planeaciones, setPlaneaciones] = useState([]);
    const [mRecibas, setMRecibas] = useState([]);
    const [recibaOriginal, setRecibaOriginal] = useState([]);
    const [locacionesDisponibles, setLocacionesDisponibles] = useState([]);
    const [locacionesSinFiltro, setLocacionesSinFiltro] = useState([]);
    const [formState, updateFormState] = useState(initialfFormState);
    const [isDisabled, setisDisabled] = useState(false);
    const [isDisabledl, setisDisabledl] = useState(false);
    const [faltanDatosUbicacion, setFaltanDatosUbicacion] = useState(false);
    const [estadoReciba, setEstadoReciba] = useState("enPlanta");
    const [search, setSearch] = useState("");
    const [searchBy, setSearchBy] = useState("cliente");
    const [totalRecords, setTotalRecords] = useState(0);
    const { formType } = formState;
    const [mensajeAlert, setMensajeAlert] = useState("Hola");
    const [color, setColor] = useState("warning");
    const userName = window.$name;
    const pubicacion = window.$Ubicacion ? window.$Ubicacion : false;
    const gubicacion = window.$GestionarUbicacion ? window.$GestionarUbicacion : false;
    const [aVisible, setAVisible] = useState(false);
    const [cargando, setCargando] = useState(false);
    const onDismiss = () => setAVisible(false);
    const [modal, setModal] = useState(false);
    const [inputList, setInputList] = useState([]);
    const [inputListCarga, setInputListCarga] = useState([]);
    const [inputListCargaPC, setInputListCargaPC] = useState([]);
    const [inputListPintado, setInputListPintado] = useState([]);
    const [inputListPintadoPC, setInputListPintadoPC] = useState([]);
    const [inputListInspeccion, setInputListInspeccion] = useState([]);
    const [inputListInspeccionPC, setInputListInspeccionPC] = useState([]);
    const [locacionData, updateLocacionData] = useState({ locacion: '', espacio: 1, ocupado: false, activo: true })
    const [inputListUbicaciones, setInputListUbicaciones] = useState([initialFormState]);
    const [activeTab, setActiveTab] = useState('1');
    const [locacionEstado, setLocacionEstado] = useState("Mostrar");
    const [ultimoNumeroP, setultimoNumeroP] = useState(3);
    const [paginas, setPaginas] = useState([]);
    const [packings, setPackings] = useState(1);
    var now = new Date();
    var now2 = new Date();
    now2.setMonth(now2.getMonth() - 1);
    const [ufechaini, setUfechaini] = useState(now2);
    const [ufechafin, setUfechafin] = useState(now);

    const toggle1 = tab => {
        if (activeTab !== tab) setActiveTab(tab);
        if (tab > 1) setAVisible(false);
    }

    const toggle = () => setModal(!modal);

    // current page
    const [currentPage, setCurrentPage] = useState(1);
    const [currentPageLocation, setCurrentPageLocation] = useState(1);

    // total records per page to display
    const recordPerPage = 20;

    // range of pages in paginator
    const pageRange = 5;

    // handle change event
    function handlePageChange(pageNumber) {
        setAVisible(false);
        setCurrentPage(pageNumber);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, pageNumber);
    }

    function handlePageChangeLocacion(locacionesFromAPI, pageNumber) {
        setAVisible(false);
        setCurrentPageLocation(pageNumber);

        setLocaciones(locacionesFromAPI.filter(locacion => locacion.indexpag === pageNumber));
        //busquedaPlaneacion(planeacionSinFiltro, pageNumber, fechaPBusqueda); 
    }

    function onestadoReciba(e) {
        setEstadoReciba(e.target.value);
        fetchAlmacen(e.target.value, ufechaini, ufechafin);
        //busqueda(recibaSinFiltro, e.target.value, searchBy, search, currentPage)
    }

    function FaltanDatosUbicación(list) {
        var fdatos = false;
        list.map((ubicacion, i) => {
            if (ubicacion.activo) {
                if (!ubicacion.ubicacion || !ubicacion.fechaIngreso || !ubicacion.horaIngreso) {
                    fdatos = true;
                };
            };
        });
        setFaltanDatosUbicacion(fdatos);
    };
    async function busqueda(recibasinf, estadoReciba, searchb, search, currentPage) {
        /*setMensajeAlert(Moment(search).format("DD/MM/YYYY"));
        setColor("warning");
        setAVisible(true);*/
        var pag = 1;
        var bandera = 1;
        //Filtrado de datos por la búsqueda y el estado de reciba
        const recibaFromAPI = recibasinf.sort((a, b) =>
            a.numero < b.numero ? 1 : a.numero > b.numero ? -1 : 0).filter(reciba =>
                searchb === "numero de parte" ? reciba.numerodeParte.toLowerCase().includes(search.toLowerCase()) :
                    searchb === "cliente" ? reciba.cliente.toLowerCase().includes(search.toLowerCase()) :
                        searchb === "id de reciba" ? reciba.numero.toLowerCase().includes(search.toLowerCase()) :
                            searchb === "serial" ? reciba.serial.toLowerCase().includes(search.toLowerCase()) :
                                searchb === "serial BTI" ? reciba.serialRecibaBTI ? reciba.serialRecibaBTI.toLowerCase().includes(
                                    search.toLowerCase()) : "".includes(search.toLowerCase()) :
                                    searchb === "paking" ? reciba.packing.toLowerCase().includes(search.toLowerCase()) :
                                        searchb === 'lote' ? reciba.lote.toLowerCase().includes(search.toLowerCase()) :
                                            searchb === 'estatus' ? reciba.status.toLowerCase().includes(search.toLowerCase()) :
                                                searchb === 'ubicación' ? reciba.ubicaciones.toLowerCase().includes(search.toLowerCase()) :
                                                    reciba.fechayHoraDeReciba.includes(Moment(search).format("DD/MM/YYYY")));


        await Promise.all(recibaFromAPI.map(async reciba => {
            //producto.indexnum=bandera;
            reciba.indexpag = pag;
            bandera++;
            if (bandera > recordPerPage) {
                bandera = 1;
                pag++;
            }

            return reciba;
        }))


        const lengthreciba = recibaFromAPI.length;
        if (lengthreciba <= 0)
            setCurrentPage(1);

        setReciba(recibaFromAPI.filter(reciba => reciba.indexpag === currentPage).sort((a, b) =>
            a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0));
        setTotalRecords(lengthreciba);

        if (currentPage > 1 && lengthreciba > 0) {
            const prepaginas = parseInt(lengthreciba / recordPerPage);
            const paginas = prepaginas * recordPerPage < lengthreciba ? prepaginas + 1 : prepaginas;
            if (currentPage > paginas) {
                setCurrentPage(paginas);
                const recibaFromAPIp = recibaFromAPI.sort((a, b) =>
                    a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0).filter(reciba =>
                        reciba.indexpag === paginas);
                setReciba(recibaFromAPIp.sort((a, b) =>
                    a.numerodeParte < b.numerodeParte ? 1 : a.numerodeParte > b.numerodeParte ? -1 : 0));
            }
        }
    }

    //Obtiene los datos de Locaciones no ocupadas
    async function fetchLocacionDisponible() {
        let filter = {
            activo: {
                eq: true
            },
            ocupado: {
                eq: false
            }
        }

        //Se obtienen las locaciones disponibles        
        const apiData = await GetLocaciones(filter);
        const locacionesFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);

        setLocacionesDisponibles(locacionesFromAPI);
    }


    //Método useEffect
    useEffect(() => {
        fetchAlmacen(estadoReciba, ufechaini, ufechafin);
        fetchLocacion();
    }, []);


    //Obtiene los datos guardados de Locación
    async function fetchLocacion() {
        var pag = 1;
        var i = 1;
        var index = 1
        var paginasp = [];
        let filter = {
            activo: {
                eq: true
            }
        }


        //Se obtienen las locaciones activas
        const apiData = await GetLocaciones(filter);
        //Se ordenan las locaciones por orden
        const locacionesFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        await Promise.all(locacionesFromAPI.map(async locacion => {
            locacion.indexpag = pag;
            index++;
            if (index > 12) {
                paginasp.push({ pagina: pag, paginareal: pag });
                index = 1;
                pag++;
            }
            locacion.color = "";
            if (i === 2) {
                locacion.color = "table-active";
                i = 0;
            }
            i++;

            return locacion;
        }))

        if (locacionesFromAPI.length) {
            setPaginas(paginasp);
        } else {
            setPaginas([]);
        }
        setLocacionesSinFiltro(locacionesFromAPI);
        handlePageChangeLocacion(locacionesFromAPI, 1);
    }
    //Obtiene los datos guardados de Locación y revisa si la locación guardada ya existe
    async function fetchLocacionRepetida(locacionr) {
        var repetida = false;
        let filter = {
            activo: {
                eq: true
            }
        }

        //Se obtienen las locaciones activas        
        const apiData = await GetLocaciones(filter);
        //Se filtran las locaciones tratando de obtener las repetidas
        const locacionesFromAPI = apiData.filter(locacion => locacion.locacion.toLowerCase() === locacionr.toLowerCase());
        if (locacionesFromAPI.length > 0)
            repetida = true;

        return repetida
    }
    //Obtiene los datos guardados de Almacen
    async function fetchAlmacen(estadoMaterial, fechainicial, fechafinal) {
        setCargando(true);
        try {
            var pag = 1;
            var bandera = 1;
            var recibaFromAPI = [];
            if (estadoMaterial === "enPlanta") {
                let filter = {
                    activo: {
                        eq: true
                    }
                }

                //Se obtienen los seriales de la reciba 
                var apiData = await GetRecibaSerialesMP(filter);
                //Se ordenan los datos por fecha de creación     
                recibaFromAPI = apiData.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);

                await Promise.all(recibaFromAPI.map(async (reciba, i) => {

                    //setMensajeAlert(JSON.stringify(rec));
                    //var reciba = rec.recibaSerialID ? await GetRecibaSerialesID(rec.recibaSerialID) : {};
                    reciba.indexpag = pag;
                    reciba.ubicaciones = reciba.ultimaUbicacion ? obtenerUltimasUbicaciones(reciba.ultimaUbicacion) : "";
                    bandera++;
                    if (bandera > recordPerPage) {
                        bandera = 1;
                        pag++;
                    }
                    return reciba;
                }))
            } else {

                let filter = {
                    and: [{
                        activo: {
                            eq: true
                        }
                    },
                    {
                        fechaDeReciba: {
                            ge: !fechainicial ? ufechaini : fechainicial
                        }
                    },
                    {
                        fechaDeReciba: {
                            le: !fechafinal ? ufechafin : fechafinal
                        }
                    }
                    ]
                }
                //Se obtienen los seriales de la reciba 
                const apiData = await GetRecibaSeriales(filter);
                //Se ordenan los datos por fecha de ceración     
                recibaFromAPI = apiData.sort((a, b) =>
                    a.createdAt < b.createdAt ? 1 : a.createdAt > b.createdAt ? -1 : 0);
                await Promise.all(recibaFromAPI.map(async reciba => {
                    reciba.indexpag = pag;
                    reciba.ubicaciones = reciba.ultimaUbicacion ? obtenerUltimasUbicaciones(reciba.ultimaUbicacion) : "";
                    bandera++;
                    if (bandera > recordPerPage) {
                        bandera = 1;
                        pag++;
                    }

                    return reciba;
                }))
            }
            setRecibaSinFiltro(recibaFromAPI);
            await busqueda(recibaFromAPI, estadoReciba, searchBy, search, currentPage);
            setCargando(false);
        } catch (error) {
            setMensajeAlert(estadoMaterial + " " + error.message)
            setAVisible(true);
            setColor("warning")
            setCargando(false);
        }
    }
    //Obtiene los datos guardados de Ubicacion
    async function fetchUbicacion(reciba) {
        setCargando(true);
        var listu = [];

        //Se obtienen los datos de la ubicación por id de secibaSerial
        const recibaSerial = await GetRecibaSerialesID(reciba.id);
        const apiData = await ObtenerUbicaciones(recibaSerial.rubicaciones);
        const apiDataCarga = recibaSerial.registroCarga ? await decodificarTextoJSON(recibaSerial.registroCarga) : [];
        const apiDataCargaPC = recibaSerial.registroCargaPC ? await decodificarTextoJSON(recibaSerial.registroCargaPC) : [];
        const apiDataPintado = recibaSerial.registroPintado ? await decodificarTextoJSON(recibaSerial.registroPintado) : [];
        const apiDataPintadoPC = recibaSerial.registroPintadoPC ? await decodificarTextoJSON(recibaSerial.registroPintadoPC) : [];
        const apiDataInspeccion = recibaSerial.registroInspeccionF ? await decodificarTextoJSON(recibaSerial.registroInspeccionF) : [];
        const apiDataInspeccionPC = recibaSerial.registroInspeccionFPC ? await decodificarTextoJSON(recibaSerial.registroInspeccionFPC) : [];
        const ubicacionFromAPI = apiData.sort((a, b) =>
            a.orden > b.orden ? 1 : a.orden < b.orden ? -1 : 0);
        setInputList(ubicacionFromAPI);
        setInputListCarga(apiDataCarga);
        setInputListCargaPC(apiDataCargaPC);
        setInputListPintado(apiDataPintado);
        setInputListPintadoPC(apiDataPintadoPC);
        setInputListInspeccion(apiDataInspeccion);
        setInputListInspeccionPC(apiDataInspeccionPC);
        setCargando(false);
    }
    function obtenerUltimaUbicaciont(ubicacion) {
        return <>
            <Table className="bordersubtabla">
                <Thead>
                    <Tr>
                        <Th className="subtablah bordersubtabla">Ubic.</Th>
                        <Th className="subtablah bordersubtabla">Loc.</Th>
                        <Th className="subtablah bordersubtabla">Pzs.</Th>
                        <Th className="subtablah bordersubtabla">Esp.</Th>
                    </Tr>
                </Thead>
                <Tbody>
                    {ubicacion && (
                        <>
                            {ubicacion.map(x => (
                                <Tr>
                                    <Td className="bordersubtabla">{x.substr(1, x.search(',') - 1).replace('ubicacion=', '')}</Td>
                                    <Td className="bordersubtabla">{x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', '')}</Td>
                                    <Td className={x.substr(x.search('locacion=') + 8, x.length).substr(1, x.substr(x.search('locacion=') + 8, x.length).search(',') - 1).replace('locacion=', '') ? "bordersubtabla" : "bordersubtabla margintopmobil20px"}>{x.substr(x.search('cantidad=') + 8, x.length).substr(1, x.substr(x.search('cantidad=') + 8, x.length).search(',') - 1).replace('cantidad=', '')}</Td>
                                    <Td className="bordersubtabla">{x.substr(x.search('espacio=') + 7, x.length).substr(1, x.substr(x.search('espacio=') + 7, x.length).search('}') - 1).replace('espacio=', '')}</Td>
                                </Tr>

                            ))}
                        </>)}
                </Tbody>
            </Table>
        </>
    }
    function obtenerUltimasUbicaciones(ubicacion) {
        var ubicaciones = "";
        ubicacion.map(x => (
            ubicaciones = ubicaciones + " " + x.substr(1, x.search(',') - 1).replace('ubicacion=', '')

        ));
        return ubicaciones;
    }
    function cantidadValida(list) {
        var cantidadnovalida = false;
        list.map(ubicacion => {
            if (mRecibas.cantidadRecibida < ubicacion.cantidad)
                cantidadnovalida = true;
        });
        return cantidadnovalida;
    }
    //Función para guardar los cambios de la ubicación.
    async function manageUbicacion() {
        setAVisible(false);
        setCargando(true);
        setisDisabled(true);
        const cantidadnoValida = cantidadValida(inputList);
        var cambios = { tabla: "recibaSeriales", valorAnterior: mRecibas, valorActual: "primary", Reg_Ins_Usuario: userName };
        try {
            //Se revisa si faltan datos
            if (faltanDatosUbicacion || cantidadnoValida === true) {
                setMensajeAlert("Faltan datos o no son válidos: los campos marcados con un asterisco son obligatorios, las cantidades mayores a las recibidas se marcan en rojo");
                setColor("warning");
                setAVisible(true);
                setCargando(false);
                window.scrollTo(0, 0);
                setisDisabled(false);
            } else {
                //Si no faltan datos, se seriva concurrencia
                const ureciba = await GetRecibaSerialesID(mRecibas.id);
                if ((ureciba.updatedAt ? ureciba.updatedAt : "") != mRecibas.updatedAt) {
                    window.scrollTo(0, 0);
                    setMensajeAlert("No fue posible realizar la operación: existe concurrencia, se requiere cancelar la operación y " +
                        " volver a intentarlo");
                    setColor("warning");
                    setCargando(false);
                    setAVisible(true);
                    fetchAlmacen(estadoReciba, ufechaini, ufechafin);
                    return;
                } else {
                    setMensajeAlert("No fue posible realizar la operación:Datos obtenidos");
                    //Se obitenen los datos de útlima ubicación
                    //Se agrupan las ubicaciones de última ubicación
                    const sUltimaU = inputList.filter((ubicacion) =>
                        ubicacion.fechaSalida === "" && ubicacion.activo === true).sort((a, b) =>
                            a.ubicacion + (a.locacion ? a.locacion : "") >
                                b.ubicacion + (b.locacion ? b.locacion : "")
                                ? 1
                                : a.ubicacion + (a.locacion ? a.locacion : "") <
                                    b.ubicacion + (b.locacion ? b.locacion : "")
                                    ? -1
                                    : 0
                        );
                    //Se obtienen los datos de última ubicación
                    var auxUltimaUbicacion = [];
                    var ubicacionLocacionanterior =
                        (sUltimaU[0].ubicacion ? sUltimaU[0].ubicacion : "") +
                        (sUltimaU[0].locacion ? sUltimaU[0].locacion : "");
                    var cantidadTotal = 0;
                    var espacio = 0;
                    await Promise.all(
                        sUltimaU.map(async (ubicacion, i) => {
                            const ubicacionLocacion =
                                (ubicacion.ubicacion ? ubicacion.ubicacion : "") +
                                (ubicacion.locacion ? ubicacion.locacion : "");
                            if (ubicacionLocacion !== ubicacionLocacionanterior) {
                                auxUltimaUbicacion.push({
                                    ubicacion: sUltimaU[i - 1].ubicacion,
                                    locacion: sUltimaU[i - 1].locacion,
                                    cantidad: cantidadTotal,
                                    espacio: espacio,
                                });
                                ubicacionLocacionanterior = ubicacionLocacion;
                                cantidadTotal = 0;
                                espacio = 0;
                            }
                            cantidadTotal = cantidadTotal + ubicacion.cantidad;
                            espacio = espacio + ubicacion.espacio;

                            if (i === sUltimaU.length - 1) {
                                auxUltimaUbicacion.push({
                                    ubicacion: ubicacion.ubicacion,
                                    locacion: ubicacion.locacion,
                                    cantidad: cantidadTotal,
                                    espacio: espacio,
                                });
                            }
                        })
                    );
                    mRecibas.rubicaciones = inputList;
                    if (inputListCarga.length > 0) {
                        mRecibas.registroCarga = inputListCarga;
                    }
                    if (inputListCargaPC.length > 0) {
                        mRecibas.registroCargaPC = inputListCargaPC;
                    }
                    if (inputListPintado.length > 0) {
                        mRecibas.registroPintado = inputListPintado;
                    }
                    if (inputListPintadoPC.length > 0) {
                        mRecibas.registroPintadoPC = inputListPintadoPC;
                    }
                    if (inputListInspeccion.length > 0) {
                        mRecibas.registroInspeccionF = inputListInspeccion;
                    }
                    if (inputListInspeccionPC.length > 0) {
                        mRecibas.registroInspeccionFPC = inputListInspeccionPC;
                    }
                    mRecibas.ultimaUbicacion = auxUltimaUbicacion;
                    delete mRecibas.createdAt;
                    delete mRecibas.updatedAt;
                    delete mRecibas.__typename;
                    delete mRecibas.indexpag;
                    delete mRecibas.ubicaciones;
                    //Se revisa si se tiene que agregar un registro a recibaSerialesMP
                    if (mRecibas.piezasEnPlanta === true || mRecibas.piezasEnPlanta === "true") {
                        //Se crean los datos en recibaSerialesMP
                        setMensajeAlert("Obteniendo datos 1");
                        const recibaSMP = await GetRecibaSerialesIDMP(mRecibas.recibaSerialMPID)
                        setMensajeAlert("Obteniendo datos 2");
                        if (!recibaSMP) {
                            setMensajeAlert("Obteniendo datos 3");
                            const recibaSerialIDOR = mRecibas.id;
                            delete mRecibas.recibaSerialMPID;
                            delete mRecibas.id;
                            setMensajeAlert("No fue posible realizar la operación:Error al crear recibaSerialesMP");
                            let serialesMP = await API.graphql({
                                query: createRecibaSerialesMP,
                                variables: { input: { ...mRecibas, recibaSerialID: recibaSerialIDOR } },
                            });
                            //Se obtienen los datos de recibaSerialesMP recién creados
                            var recibaMPCreada = serialesMP.data.createRecibaSerialesMP;
                            mRecibas.recibaSerialMPID = recibaMPCreada.id;
                            mRecibas.id = recibaSerialIDOR;
                        }
                    }

                    if (!mRecibas.piezasCtnaRecuperadas) { delete mRecibas.piezasCtnaRecuperadas };
                    if (!mRecibas.piezasInspeccion) { delete mRecibas.piezasInspeccion };
                    if (!mRecibas.piezasInspeccionPC) { delete mRecibas.piezasInspeccionPC };
                    if (!mRecibas.piezasIRecuperacion) { delete mRecibas.piezasIRecuperacion };
                    if (!mRecibas.piezasCRecuperacion) { delete mRecibas.piezasCRecuperacion };
                    if (!mRecibas.PiezasCtnaRecuperacion) { delete mRecibas.PiezasCtnaRecuperacion };
                    if (!mRecibas.piezasTRecuperacion) { delete mRecibas.piezasTRecuperacion };
                    if (!mRecibas.piezasRecuperadas) { delete mRecibas.piezasRecuperadas };
                    if (!mRecibas.piezasFacturadas) { delete mRecibas.piezasFacturadas; }
                    if (!mRecibas.UltimaInspeccionCuarentena) { delete mRecibas.UltimaInspeccionCuarentena; }
                    if (!mRecibas.piezasCtnaNRecuperadas) { delete mRecibas.piezasCtnaNRecuperadas; };


                    setMensajeAlert("No fue posible realizar la operación:Error al guardar la reciba" + JSON.stringify(mRecibas));
                    let resutl = await API.graphql({ query: updateRecibaSeriales, variables: { input: mRecibas } });
                    cambios.valorActual = resutl.data.updateRecibaSeriales;
                    //Se obtienen los datos para agregar, eliminar o actualizar los datos de recibaSerialesMP
                    const recibaActualizada = resutl.data.updateRecibaSeriales;
                    if (mRecibas.piezasEnPlanta === false || mRecibas.piezasEnPlanta === "false") {
                        setMensajeAlert("No se pudo eliminar de la tabla temporal; ");
                        await API.graphql({ query: deleteRecibaSerialesMP, variables: { input: { id: mRecibas.recibaSerialMPID } } });
                    } else {
                        //Se actualizan los datos en recibaSerialesMP
                        const recibaSerialMPID = mRecibas.recibaSerialMPID;
                        if (mRecibas.recibaSerialMPID) {
                            delete mRecibas.recibaSerialMPID;
                            setMensajeAlert("Operación errónea; Problemas al guardar los datos del serial" + JSON.stringify(mRecibas));
                            await API.graphql({ query: updateRecibaSerialesMP, variables: { input: { ...mRecibas, id: recibaSerialMPID, rsUpdatedAt: recibaActualizada.updatedAt, recibaSerialID: mRecibas.id } }, });
                        }
                    }
                    //Se guarda el historial de cambios
                    await API.graphql({
                        query: createCambios,
                        variables: { input: cambios },
                    });
                    window.scrollTo(0, 0);
                    setMensajeAlert("Operación exitosa ");
                    setColor("primary");
                    setAVisible(true);
                    setCargando(false);
                    fetchAlmacen(estadoReciba, ufechaini, ufechafin);
                    palmacen();
                }
            }

        } catch (e) {
            window.scrollTo(0, 0);
            /*setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar");*/
            setColor("warning");
            fetchAlmacen(estadoReciba, ufechaini, ufechafin);
            setAVisible(true);
            setCargando(false);
            setisDisabled(false);
        }
    }
    function liberarLocaciones() {
        inputList.map((series, i) => {
            if (series.locacion !== "" && series.locacion !== series.locacionOriginal) {
                const locacionae = locacionesSinFiltro.filter(locacion => locacion.locacion === series.locacion);
                if (locacionae[0]) {
                    liberarlocacion(locacionae[0]);
                }
            }

        });

    };
    function cancelarGUbicacion() {
        fetchLocacion();
        liberarLocaciones();
        palmacen();
    }
    function palmacen() {
        setInputList([]);
        setInputListCarga([]);
        setInputListCargaPC([]);
        setMRecibas({ ...reciba });
        fetchLocacion();
        updateFormState(() => ({ ...formState, formType: "Ubicación" }));
    }
    async function clicGestionar(reciba) {
        setAVisible(false);
        setisDisabled(false);
        setRecibaOriginal(reciba);
        const datosReciba = estadoReciba === "enPlanta" ? reciba.recibaSerialID ? await GetRecibaSerialesID(reciba.recibaSerialID) : {} : reciba;
        setMRecibas({ ...datosReciba });
        fetchUbicacion(datosReciba);
        fetchLocacionDisponible();
        updateFormState(() => ({ ...formState, formType: "Gestionar ubicación" }));
    }
    async function regresarMaterialAPlanta(reciba) {
        window.scrollTo(0, 0);
        setAVisible(false);
        setCargando(true);
        try {
            const regresarPlanta = await regresarAPlanta(reciba, userName)
            setMensajeAlert(regresarPlanta.mensaje);
            setColor(regresarPlanta.color);
            setAVisible(true);
            setCargando(false);
            fetchAlmacen(estadoReciba, ufechaini, ufechafin);

        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert(e.message);
            //"No fue posible terminar la operación: revise si la operación se realizó parcialmente, revise su conexión a internet y vuelva a intentar, si el problema persiste, favor de comunicarte a sistemas"
            setColor("warning");
            setAVisible(true);
            setCargando(false);
        }
    }

    function buscarpor(e) {
        setAVisible(false);
        setSearchBy(e.target.value);
        if (search && e.target.value !== "fecha")
            busqueda(recibaSinFiltro, estadoReciba, e.target.value, search, currentPage);
    }
    function onSearch(e) {
        setAVisible(false);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, search, currentPage);
    }
    function onSearchFecha(e) {
        setAVisible(false);
        setSearch(e.target.value);
        busqueda(recibaSinFiltro, estadoReciba, searchBy, e.target.value, currentPage);
    }
    //Obtiene los datos guardados de Locación
    async function LocacionOcupada(ID) {
        //Variable auxiliar
        var ocupado = false;
        //Se obtiene la locación por ID
        const apiData = await GetLocacionesID(ID);
        //Se filtra para determinar si la locación está ocupara
        const locacionesFromAPI = apiData.filter(locacion => locacion.ocupado === true);
        if (locacionesFromAPI.length)
            ocupado = true;
        //Se regresa true o false dedependiendo si está o no ocupado
        return ocupado;

    }
    async function managelocacion(anterior, actual, name, index, list, espacio) {
        //setMensajeAlert("Anterior " + anterior + "Actual " + actual + "Name " + name + "Index " + index + "Espacio " + espacio );
        //setMensajeAlert(<div style={{ marginTop: 20 }}>{JSON.stringify(actualLocacion[0])}</div>);
        //setColor("warning");
        //setAVisible(true);
        try {
            // Revisa si la locación actual es diferente a vacio 
            if (actual !== "") {
                //Se revisa si la locación elegida no se encuentra ocupada 
                //Se obtiene el registro de la locación actual 
                const actualLocacion = locacionesSinFiltro.filter(locacion => locacion.locacion === actual);
                if (actualLocacion[0]) {
                    if (await LocacionOcupada(actualLocacion[0].id) === false) {
                        delete actualLocacion[0].createdAt;
                        delete actualLocacion[0].updatedAt;
                        delete actualLocacion[0].__typename;
                        delete actualLocacion[0].color;
                        delete actualLocacion[0].indexpag;
                        actualLocacion[0].Reg_Mod_Usuario = userName;
                        actualLocacion[0].ocupado = true;
                        actualLocacion[0].fechaDeOcupacion = now;
                        list[index].espacioOcupado = actualLocacion[0].espacioOcupado > 0 ? actualLocacion[0].espacio - actualLocacion[0].espacioOcupado : actualLocacion[0].espacio;
                        actualLocacion[0].espacioOcupado = espacio === 0 ? actualLocacion[0].espacio : espacio;
                        await API.graphql({ query: updateLocacion, variables: { input: actualLocacion[0] } });
                        list[index][name] = actual;
                        fetchLocacionDisponible();
                        setMensajeAlert("La locación '" + actual + "' se guardó con éxito");
                    } else {
                        setMensajeAlert("La locación '" + actual + "' ya se encuentra ocupada, elige otra locación por favor");
                        //setMensajeAlert(<div style={{ marginTop: 20 }}>{JSON.stringify(actualLocacion[0])}</div>);
                        setColor("warning");
                        setAVisible(true);
                        window.scrollTo(0, 0);
                    }

                }
            } else {
                list[index][name] = actual;
                list[index].espacioOcupado = 0;
                //updateFormData(()=>({ ...formData, [serial]: list})); 
            }

            //Si se habia marcado una locación como ocupada, se desocupa.
            if (anterior !== "" && list[index].locacionOriginal !== anterior) {
                const locacionae = locacionesSinFiltro.filter(locacion => locacion.locacion === anterior)
                if (locacionae[0]) {
                    liberarlocacion(locacionae[0]);
                }
            }
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Hay problemas registrando las locaciones");
            setColor("warning");
            setAVisible(true);
            //fetchLocacionDisponible();        
        }
        // const anteriorLocacion = locaciones.filter(locacion =>locacion.locacion===actual); 
    }
    async function liberarlocacion(locacion) {
        try {
            delete locacion.createdAt;
            delete locacion.updatedAt;
            delete locacion.__typename;
            delete locacion.color;
            delete locacion.indexpag;
            locacion.Reg_Mod_Usuario = userName;
            locacion.ocupado = false;
            locacion.fechaDeliberacion = now;
            locacion.espacioOcupado = locacion.espacio - locacion.espacioOcupado;
            await API.graphql({ query: updateLocacion, variables: { input: locacion } });
            fetchLocacionDisponible();
            //setMensajeAlert("Liberación exitosa");
        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("Hay problemas liberando las locaciones");
            setColor("warning");
            setAVisible(true);
        }
    }
    // handle input change
    function handleInputChangeUbicacion(e, index, list) {
        const { name, value } = e.target;
        list[index][name] = value;
        FaltanDatosUbicación(list);
        return list
    };
    // handle input change
    function handleInputChangeProduccion(e, index, list) {
        const { name, value } = e.target;
        list[index][name] = value;
        return list
    };
    //Revisa cambios en los inputs
    function handleInputChangeDatos(e) {
        e.persist();
        const { name, value } = e.target;
        if (name === "piezasEnPlanta") {
            setMRecibas(() => ({ ...mRecibas, [name]: value }));
        } else {
            const re = /^[0-9\.]+$/;
            if (e.target.value === "" || re.test(e.target.value)) {
                setMRecibas(() => ({ ...mRecibas, [name]: name === "racks" ? value : value === "" ? 0 : parseInt(value) }));
            }
        }
    }
    function ultimaubicacionactiva(list, indexinicial) {
        var ultimoindiceactivo = 0;

        for (var i = indexinicial; i >= 0; i--) {

            if (list[list[i].ultimoAnterior].activo === true) {
                ultimoindiceactivo = list[i].ultimoAnterior;
                i = 0;
            } else {
                i = list[i].ultimoAnterior + 1;
            }
        }
        return ultimoindiceactivo
    }
    // handle click event of the Remove button
    function handleRemoveClick(index, list) {
        list.splice(index, 1);
        FaltanDatosUbicación(list);
        return list;
    };
    // handle click event of the Add button
    function handleAddClick(index, list) {
        fetchLocacionDisponible();
        FaltanDatosUbicación(list);
        list[index].ultimo = false;
        list[index].fechaSalida = !list[index].fechaSalida || list[index].fechaSalida ? Moment(new Date()).format("YYYY-MM-DD") : list[index].fechaSalida;
        list[index].horaSalida = !list[index].horaSalida || list[index].horaSalida === '00:00' ? Moment(new Date()).format("HH:mm") : list[index].horaSalida;
        return list
    };

    //Ordena los  packings de la lista de recibas
    function obtenerPacking(list) {
        var listPacking = [];
        var packings = "";
        var packingsn = 1;

        list.map((packing, i) => {
            if (packings !== packing.packing) {
                listPacking.push({ packing: packing.packing, packingindex: packingsn });
                packingsn = packingsn + 1;
                packings = packing.packing;
            }
        });
        setPackings(packingsn);
        return listPacking
    }
    //Ordena los seriales de la lista de recibas tomando en cuenta los packings
    function obtenerSerialesMostrar(list, packings, idSerial) {
        var seriallist = [];
        var sombra = true;
        packings.map((packing, i) => {
            sombra = !sombra;
            list.map((serial) => {
                if (serial.packing === packing.packing) {
                    serial.sombreado = sombra;
                    seriallist.push(serial);
                    serial.locacionOriginal = serial.locacion;
                }
                if (serial.id === idSerial)
                    serial.sombreado = true;
                else
                    serial.sombreado = false;
            });
        });
        return seriallist
    }

    //Obtiene los datos guardados de RecibaSeriales por ID de reciba
    async function fetchRecibaSerialporID(recibaID) {
        let filter = {
            recibaID: {
                eq: recibaID
            },
            activo: {
                eq: true
            }
        }
        //Obteniendo los datos de los seriales/contenedores       
        const dataSeriales = await GetRecibaSeriales(filter);
        //Se ordenan los datos por la fecha de creación
        const recibaSerialesFromAPI = dataSeriales.sort((a, b) =>
            a.createdAt > b.createdAt ? 1 : a.createdAt < b.createdAt ? -1 : 0)
        //setRecibaSerialesSinFiltro(recibaSerialesFromAPI);
        return recibaSerialesFromAPI;
    }

    function leerubicacioneditar(reciba) {
        var list = [];

        list.push({
            recibaID: reciba.recibaID, RecibaSerialesID: reciba.id, fechaDeReciba: reciba.fechaDeReciba,
            ubicaciondeReciba: true, lote: reciba.lote, serial: reciba.serial, serialRecibaBTI: reciba.serialRecibaBTI,
            cantidad: reciba.cantidadRecibida, ubicacion: reciba.ubicacion, locacion: reciba.locacion,
            espacioOcupado: reciba.espacioOcupado, comentarios: "", activo: true, orden: 0,
            fechaIngreso: reciba.fechaDeUbicacion, horaIngreso: reciba.horaDeUbicacion, horaSalida: "00:00",
            ultimo: true, ultimoAnterior: 0, Reg_Ins_Usuario: "", Reg_Mod_Usuario: "", nuevo_registro: true,
            locacionOriginal: reciba.locacion

        })

        return list;
    }

    async function cliclMostrar(reciba) {
        setCargando(true);
        setAVisible(false);
        //Se obtiene la reciba por ID
        const listas = await GetRecibaID(reciba.recibaID);
        //Si ya se registró material en planeación, se obtienen los datos de la planeación y del plan de producción
        if (reciba.cantidadPlaneada > 0) {
            const pproduccion = await GetPProduccion({ and: [{ recibaSerialID: { eq: reciba.id } }, { activo: { eq: true } }] });
            const planeacion = await GetPlaneacion({ and: [{ recibaSerialID: { eq: reciba.id } }, { activo: { eq: true } }] });
            setPProduccion(pproduccion.sort((a, b) =>
                a.fechaDePlaneacion < b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion > b.fechaDePlaneacion ? -1 : 0));
            setPlaneaciones(planeacion.sort((a, b) =>
                a.fechaDePlaneacion < b.fechaDePlaneacion ? 1 : a.fechaDePlaneacion > b.fechaDePlaneacion ? -1 : 0))
        } else {
            setPProduccion([]);
            setPlaneaciones([])

        }
        setMRecibas({ ...listas, Reg_Mod_Usuario: userName });
        const seriales = await fetchRecibaSerialporID(reciba.recibaID);
        const packings = obtenerPacking(seriales.sort((a, b) =>
            a.packingindex > b.packingindex ? 1 : a.packingindex < b.packingindex ? -1 : 0));
        setInputList(obtenerSerialesMostrar(seriales.sort((a, b) =>
            a.numerodeParte > b.numerodeParte ? 1 : a.numerodeParte < b.numerodeParte ? -1 : 0), packings, reciba.id));
        updateFormState(() => ({ ...formState, formType: "Detalle Reciba " + reciba.numero }));
        setCargando(false);
    }

    function clicAgregarLocacion() {
        updateLocacionData(() => ({ ...locacionData, ['locacion']: '', ['espacio']: 1, ['ocupado']: false, ['activo']: true, ['Reg_Ins_Usuario']: '' }));
        setLocacionEstado("Nueva");
        setAVisible(false);
    }
    //Revisa cambios en los inputs
    function onChanges(e) {
        e.persist()
        updateLocacionData(() => ({ ...locacionData, [e.target.name]: e.target.value }));
    }
    async function guardarLocacion() {
        setAVisible(false);
        setisDisabledl(true);
        try {
            if (locacionData.locacion === "") {
                setMensajeAlert("Faltan datos: los campos marcados con un asterisco son obligatorios");
                setColor("warning");
                setAVisible(true);
                window.scrollTo(0, 0);
                setisDisabledl(false);
            } else {
                const repetida = await fetchLocacionRepetida(locacionData.locacion);
                if (repetida === true) {
                    setMensajeAlert("Locación repetida; ingrese una locación diferente y vuelva a intentarlo " + repetida + " L:" + locacionData.locacion);
                    setColor("warning");
                    setAVisible(true);
                    window.scrollTo(0, 0);
                    setisDisabledl(false);
                } else {
                    locacionData.Reg_Ins_Usuario = userName;
                    await API.graphql({ query: createLocacion, variables: { input: locacionData } });
                    setMensajeAlert("Operación exitosa");
                    setColor("primary");
                    setAVisible(true);
                    setCargando(true);
                    setLocacionEstado("Mostrar");
                    setisDisabledl(false);
                    fetchLocacion();

                }
            }

        } catch (e) {
            window.scrollTo(0, 0);
            setMensajeAlert("No fue posible realizar la operación: revise su conexión a internet y vuelva a intentar");
            setColor("warning");
            fetchAlmacen(estadoReciba, ufechaini, ufechafin);
            setAVisible(true);
            setisDisabledl(false);
        }
    }
    //Revisa cambios en la fecha de búsqueda
    function onChangesUFechaini(e) {
        e.persist()
        var fechaini = ufechaini;
        var fechafin = ufechafin;
        if (e.target.name === "rFechaIni") {
            fechaini = e.target.value;
        } else {
            fechafin = e.target.value;
        }
        setUfechafin(fechafin);
        setUfechaini(fechaini);
        fetchAlmacen(estadoReciba, fechaini, fechafin);

    }
    return {
        pubicacion,
        formType,
        mRecibas,
        recibaOriginal,
        color,
        aVisible,
        mensajeAlert,
        cargando,
        inputList,
        inputListCarga,
        inputListCargaPC,
        inputListPintado,
        inputListPintadoPC,
        inputListInspeccion,
        inputListInspeccionPC,
        estadoReciba,
        searchBy,
        search,
        ufechaini,
        ufechafin,
        reciba,
        currentPage,
        recordPerPage,
        totalRecords,
        planeaciones,
        pProduccion,
        gubicacion,
        pageRange,
        locacionesDisponibles,
        isDisabled,
        palmacen,
        fetchAlmacen,
        clicGestionar,
        regresarMaterialAPlanta,
        onDismiss,
        buscarpor,
        setRecibaOriginal,
        onestadoReciba,
        setSearch,
        cancelarGUbicacion,
        onSearchFecha,
        onSearch,
        obtenerUltimaUbicaciont,
        cliclMostrar,
        manageUbicacion,
        onChangesUFechaini,
        handlePageChange,
        setInputList,
        setInputListCarga,
        setInputListCargaPC,
        setInputListPintado,
        setInputListPintadoPC,
        setInputListInspeccion,
        setInputListInspeccionPC,
        handleInputChangeUbicacion,
        handleInputChangeProduccion,
        handleInputChangeDatos,
        handleAddClick,
        handleRemoveClick
    }
}